module.exports = __webpack_public_path__ + "toBride2-we-b-g.6b601c04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-b-g.jpg
// module id = falD
// module chunks = 0